module.exports = __webpack_public_path__ + "sb.40725ee9.svg";